import { createContext, useContext, useState, useEffect } from 'react'

const LanguageContext = createContext()

const languages = {
  az: { name: 'Azərbaycan', flag: '🇦🇿' },
  ru: { name: 'Русский', flag: '🇷🇺' },
  en: { name: 'English', flag: '🇺🇸' },
  ko: { name: '한국어', flag: '🇰🇷' },
  kk: { name: 'Қазақша', flag: '🇰🇿' },
  ky: { name: 'Кыргызча', flag: '🇰🇬' }
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('admin-language') || 'en'
  })

  useEffect(() => {
    localStorage.setItem('admin-language', currentLanguage)
  }, [currentLanguage])

  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setCurrentLanguage(lang)
      window.location.reload()
    }
  }

  const getApiHeaders = () => {
    return {
      'Content-Type': 'application/json',
      'lang': currentLanguage
    }
  }

  const value = {
    currentLanguage,
    languages,
    changeLanguage,
    getApiHeaders
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}
